import type { AgentMode } from "../api/types";

export type AgentBuildMode = AgentMode | "all";

const RAW = (import.meta.env.VITE_AGENT_MODE ?? "all").toLowerCase();
const KNOWN: AgentBuildMode[] = ["all", "bafa", "inqa", "qm_handbuch", "custom_document"];

function parseBuildMode(): AgentBuildMode {
  return (KNOWN as string[]).includes(RAW) ? (RAW as AgentBuildMode) : "all";
}

const buildMode: AgentBuildMode = parseBuildMode();

const TITLES: Record<AgentBuildMode, string> = {
  all: "ZWW Agent",
  bafa: "BAFA Bericht",
  inqa: "INQA Projektreferenz",
  qm_handbuch: "QM Handbuch",
  custom_document: "Eigenes Dokument",
};

export interface AppConfig {
  /** Build-time agent flavor — `all` is the multi-mode root build. */
  buildMode: AgentBuildMode;
  /** Modes the user is allowed to switch between in this build. */
  enabledModes: AgentMode[];
  /** Mode the app starts in on first visit. */
  defaultMode: AgentMode;
  /** Whether the mode selector card grid is shown at the top of the left panel. */
  showModeSelector: boolean;
  /** Window/page title and header H1. */
  title: string;
}

const ALL_MODES: AgentMode[] = ["bafa", "inqa", "qm_handbuch", "custom_document"];

export const appConfig: AppConfig = {
  buildMode,
  enabledModes: buildMode === "all" ? ALL_MODES : [buildMode],
  defaultMode: buildMode === "all" ? "bafa" : buildMode,
  showModeSelector: buildMode === "all",
  title: TITLES[buildMode],
};
